module.exports = __webpack_public_path__ + "static/resumen-caja-ptx-ba80fb3d0d5d7397f7805e47c7aa26f0.png";